import { isNativeApp } from './platform';

export async function copyText(text) {
  try {
    if (isNativeApp()) {
      const { Clipboard } = await import('@capacitor/clipboard');
      await Clipboard.write({ string: String(text) });
    } else {
      await navigator.clipboard.writeText(String(text));
    }
    return true;
  } catch {
    window.alert('Unable to copy. Please select and copy the text manually.');
    return false;
  }
}

export async function currentLocation() {
  if (isNativeApp()) {
    const { Geolocation } = await import('@capacitor/geolocation');
    const permission = await Geolocation.requestPermissions({ permissions: ['location'] });
    if (permission.location !== 'granted') throw new Error('Precise location permission is needed to verify the trip location. Enable it in your phone settings.');
    const position = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
    return { lat: position.coords.latitude, lng: position.coords.longitude };
  }
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error('Location is unavailable on this device.'));
    navigator.geolocation.getCurrentPosition(position => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }), reject, { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
  });
}

export async function openExternal(value) {
  try {
    const url = new URL(value, window.location.href);
    if (!['https:', 'http:'].includes(url.protocol)) throw new Error('This link cannot be opened here.');
    if (isNativeApp()) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url: url.href, toolbarColor: '#D4145A', presentationStyle: 'fullScreen' });
    } else {
      window.open(url.href, '_blank', 'noopener,noreferrer');
    }
    return true;
  } catch (error) {
    window.alert(error.message || 'Unable to open this link.');
    return false;
  }
}
